// The formats offered in the order page's Download window, shared by the
// legacy and the V2 order page.
import constants, { FILE_DOWNLOAD_FORMATS } from '@/constants'
import { getConfirmationStageDownloadOptions } from '@/views/apps/order/order-confirmation-stages'

const { ORDER_STATUS } = constants

// An order (not a shipment): the whole-order confirmation once confirmed, and
// one order confirmation per confirmation stage (KP-4363).
const orderOnlyOptions = order => [
  ...(order?.status === ORDER_STATUS.CONFIRMED ? [FILE_DOWNLOAD_FORMATS.ORDER_DETAILS_PDF] : []),
  ...getConfirmationStageDownloadOptions(order),
]

export function getOrderDownloadOptions({
  order, isShipment, isShipmentOrder, canDownloadInvoice,
}) {
  const options = [FILE_DOWNLOAD_FORMATS.XLSX_STYLE, FILE_DOWNLOAD_FORMATS.XLSX_SKU]
  if (!isShipmentOrder) options.push(FILE_DOWNLOAD_FORMATS.ZIP)
  if (canDownloadInvoice) options.push(FILE_DOWNLOAD_FORMATS.PDF)
  if (isShipment) return [...options, FILE_DOWNLOAD_FORMATS.SHIPMENT_DETAILS_PDF]
  return [...options, ...orderOnlyOptions(order)]
}
